module.exports = __webpack_public_path__ + "static/img/left-cov.d81acb4a.png";